import styles from "@src/Pages/SettingsPage/settingsPage.module.less";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import {useEffect, useMemo, useState} from "react";
import faqRaw from "@src/faq.md?raw";
import {
    Body_14_Coral_Primary_Regular_14,
    Body_14_Coral_Strong_emphasis_14
} from "@UI/typography/generated/typography.tsx";
import {Minus} from "@UI/components/icons/Minus.tsx";
import {Plus} from "@UI/components/icons/Plus.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";

import { useTranslation } from 'react-i18next'
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";
import cn from "classnames";
import {FaqBuckets, FaqItem, FaqSectionKey, parseFaqByBuckets} from "@src/utils/mdParser.ts";
import {Colors} from "@UI/theme/generated/Colors.ts";
import {useCredentialsStore} from "@src/Store/userStore.ts";

export const FAQElem = ({item}: { item: FaqItem }) => {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <Stack className={cn(styles.whiteBoard, styles.questions)} gap={16} justifyContent={"flex-start"}
               onClick={() => setCollapsed(!collapsed)}
               style={{maxWidth: "588px"}}
               direction={"column"}>
            <Stack justifyContent={"space-between"}>
                <Body_14_Coral_Strong_emphasis_14>
                    {item?.question}
                </Body_14_Coral_Strong_emphasis_14>

                <Button type={ButtonType.clickableIcon}
                        color={ColorNames.OBSIDIAN}
                        icon={collapsed ? <Minus size={24}/> : <Plus size={24}/>}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{padding: 0, height: "24px"}}
                />
            </Stack>

            {collapsed &&
                <Body_14_Coral_Primary_Regular_14
                    dangerouslySetInnerHTML={{__html: item.answer}}
                    style={{color: Colors.Obsidian_Dark_300}}
                />
            }
        </Stack>
    )
}

export const FAQPage = () => {
    const { i18n } = useTranslation();
    const {employee} = useCredentialsStore()

    const [buckets, setBuckets] = useState<FaqBuckets>({} as any);

    const role = useMemo(() => employee?.is_manager ? "manager" : "employee", [employee])

    useEffect(() => {
        (async () => setBuckets(await parseFaqByBuckets(faqRaw)))();
    }, []);

    const items = useMemo(() => {
        const key = `${i18n.language}.${role}`.toLowerCase() as FaqSectionKey;
        return buckets?.[key] as FaqItem[] ?? [] as FaqItem[]
    }, [i18n, buckets, employee]);

    return (
        <Stack direction={"column"} gap={8} className={styles.subMenuPage} alignItems={"center"}>
            {items.map((it) => <FAQElem item={it} key={it.id}/>)}
        </Stack>
    )
}